import React from "react";
import { Tooltip, IconButton } from "@material-ui/core";
import classNames from "classnames";
import dashboard from "../../../images/sidebar_icon/dashboard.png";
import empDashboard from "../../../images/sidebar_icon/emp-dashboard.png";
import users from "../../../images/sidebar_icon/user.png";
import search from "../../../images/sidebar_icon/search.png";
import profileIcons from "../../../images/employee/sidebar/profile.png";

import useStyles from "../styles";
import SidebarLink from "../components/SidebarLink/SidebarLink";

const RecruiterSidebar = ({ location, isSidebarOpened }) => {
  const classes = useStyles();
  const recruiterItems = [
    {
      id: 0,
      label: "Live Status",
      link: "/app/dashboard",
      view: true,
      icon: (
        <Tooltip title="Live Status" placement="right">
          <IconButton>
            <img
              src={dashboard}
              alt="dashboard"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 1,
      label: "My Dashboard",
      link: "/app/employee_dashboard",
      view: true,
      icon: (
        <Tooltip title="My Dashboard" placement="right">
          <IconButton>
            <img
              src={empDashboard}
              alt="employee dashboard"
              className={classNames(classes.Icon1)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 2,
      label: "Profile",
      link: "/app/profile",
      view: true,
      icon: (
        <Tooltip title="Profile" placement="right">
          <IconButton>
            <img
              src={profileIcons}
              alt="Profile"
              className={classNames(classes.Icon3)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 3,
      label: "Candidates",
      link: "/app/recruiter_candidates",
      view: true,
      icon: (
        <Tooltip title="Candidates" placement="right">
          <IconButton>
            <img
              src={users}
              alt="candidates"
              className={classNames(classes.Icon3)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      id: 4,
      label: "Search Candidates",
      link: "/app/search",
      view: true,
      icon: (
        <Tooltip title="Search Candidates" placement="right">
          <IconButton>
            <img
              src={search}
              alt="candidates"
              className={classNames(classes.Icon4)}
            />
          </IconButton>
        </Tooltip>
      ),
    },
  ];
  return (
    <>
      {recruiterItems.map((link) => (
        <SidebarLink
          key={link.id}
          location={location}
          isSidebarOpened={isSidebarOpened}
          {...link}
        />
      ))}
    </>
  );
};

export default RecruiterSidebar;
